export default __webpack_public_path__ + "static/media/animation021-06.5ea8b0d6.svg";